import styled from 'styled-components';

export default styled.div<{primaryColor?: string}>(
  ({theme, primaryColor}) => `
  --primary-color: ${primaryColor ? primaryColor : theme.color.indigo[11]};
  --scrollbar-thumb: rgb(31, 31, 31);
   --scrollbar-track: transparent;
   --scrollbar-thumb-hover: rgb(64, 64, 64);
 	--scrollbar-width: 4px;

   /* Firefox */
 	scrollbar-width: thin;
 	scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);

  /* Chrome, Edge, Safari */
  *::-webkit-scrollbar {
    width: var(--scrollbar-width); /* vertical scrollbar */
    height: var(--scrollbar-width); /* horizontal scrollbar */
  }

  *::-webkit-scrollbar-track {
    background: var(--scrollbar-track);
  }

  *::-webkit-scrollbar-thumb {
    background: var(--scrollbar-thumb);
    border-radius: var(--scrollbar-width);
    border: 1px (--scrollbar-thumb-hover, 50%);
    transition: .3s background ease-in-out;
  }

  *::-webkit-scrollbar-thumb:hover {
    background: var(--scrollbar-thumb-hover);
    transition: .3s background ease-in-out;
  }

  position: relative;

  .icon::before {
    display: inline-block;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
  }

  .video-js .vjs-text-track-display .vjs-text-track-cue,
  .video-js .vjs-text-track-display .vjs-text-track-cue > div {
    font-family: Inter !important;
    padding: 0 4px;
  }

  .video-js {
    overflow: hidden;
    font-size: 16px;
    font-family: Inter;
    text-align: center;
    line-height: 16px;
    color: ${theme.color.grey[12]};

    // This class is added to the video.js element by the plugin by default.
    &.vjs-hls-quality-selector {
        display: block;
      }
    }
  }

  .vjs-playback-rate,
  .vjs-quality-selector {
    display: none !important;
  }

  .scaleup-ai > .vjs-menu {
    display: none;
  }

  .scaleup-ai svg {
    pointer-events: none;
  }

  .video-js .vjs-big-play-button {
    display: none;
    font-size: 68px;
    color: ${theme.color.grey[12]};
    opacity: 0.8;
    border: 0;
    background: transparent;
  }

  .vjs-button > .vjs-icon-placeholder:before {
    font-size: 18px;
    line-height: 24px;
  }

  .video-js .vjs-progress-control {
    display: flex;
    align-items: center;

    &>.vjs-progress-holder {
      height: 4px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 2px;
      transition: all .2s;
      margin: 0;

      &>.vjs-load-progress {
        height: 4px;
        border-radius: 99px;
        background: rgba(255, 255, 255, 0.20);
        transition: all .2s;

        &>div {
          border-radius: 2px;
        }
      }

      &>.vjs-mouse-display .vjs-time-tooltip {
        background-color: rgba(255, 255, 255, 1);
        color: rgba(0, 0, 0, 1);
        top: -40px;
        right: -23px;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
        z-index: 1 !important;
        transition: all .2s !important;
        border-radius: 4px !important;
        font-family: Inter;
        font-size: 10px;
        font-style: normal;
        font-weight: 600;
        line-height: 130%; /* 13px */
        letter-spacing: -0.2px;
        padding: 4px;
        min-width: 32px;

        &:after{
          content: " ";
          position: absolute;
          left: 50%;
          bottom: -4px;
          margin-left: -4px;
          border-width: 4px;
          border-style: solid;
          border-color: transparent rgba(255, 255, 255, 1) rgba(255, 255, 255, 1) transparent;
          border-radius: 0px 0px 2px 0px;
          transform: rotate(45deg);
        }
      }

      &>.vjs-play-progress {
        border-radius: 2px;
        background: var(--primary-color);
        height: 4px;
        transition: all .2s;

        &:before {
          opacity: 0;
          transition: opacity .2s;
          height: 4px;
          color: var(--primary-color);
          border-radius: 99px;
          top: -4px !important;
          font-size: 8px !important;
        }

        &>.vjs-time-tooltip {
          min-width: 32px;
          background-color: rgba(0, 0, 0, 1);
          color: rgba(255, 255, 255, 1);
          top: -40px;
          z-index: 0 !important;
          transition: all .2s !important;
          border-radius: 4px !important;
          font-family: Inter;
          font-size: 10px;
          font-style: normal;
          font-weight: 600;
          line-height: 130%; /* 13px */
          letter-spacing: -0.2px;
          padding: 4px;

          &:after{
            content: " ";
            position: absolute;
            left: 50%;
            bottom: -4px;
            margin-left: -4px;
            border-width: 4px;
            border-style: solid;
            border-color: transparent rgba(0, 0, 0, 0.8) rgba(0, 0, 0, 0.8) transparent;
            border-radius: 0px 0px 2px 0px;
            transform: rotate(45deg);
          }
        }
      }
    }
    &:hover {
      &>.vjs-progress-holder{
        height: 8px;

        &>.vjs-load-progress,
        &>.vjs-play-progress {
          height: 8px;
          transition: all .2s;
          &:before {
            transition: opacity 0s ease-in-out;
            color: var(--primary-color);
            border-radius: 99px;
            top: -4px !important;
            font-size: 16px !important;
            opacity: 1;
          }
        }
      }
    }
  }

  .video-js:hover .vjs-big-play-button,
  .video-js .vjs-big-play-button {
    background-color: transparent;
  }

  .video-js .vjs-menu-button.vjs-quality-selector .vjs-menu .vjs-menu-content {
    display: flex;
    min-width: 250px;
    width: max-content;
    height: auto;
    padding: 8px 0px;
    flex-direction: column;
    align-items: flex-start;
    position: absolute;
    right: -99px;
    bottom: 60px;
    border-radius: 12px;
    background: rgba(28, 28, 28, 0.8);
    gap: 8px;

    &>.vjs-menu-title {
      display: flex;
      width: 100%;
      border-bottom: 1px solid rgb(52, 52, 52);
      -webkit-box-align: center;
      align-items: center;
      height: 20px;
      justify-content: center;
    }

    &>.vjs-menu-item {
      display: flex;
      list-style: none;
      margin: 0px;
      padding: 0px;
      text-align: center;
      line-height: 0;
      width: 100% !important;
      justify-content: center;
      height: 10px;
    }
  }

  .video-js .vjs-volume-level {
    background: ${theme.color.grey[12]};
  }

  .vjs-slider-horizontal .vjs-volume-level:before {
    top: -5px;
    right: -8px;
  }

  .video-js:not(.vjs-has-started) .vjs-loading-spinner {
    display: none;
  }

  .video-js--loading,
  .video-js--loading .scaleup-custom-bar,
  .video-js--loading .scaleup-custom-bar * {
    pointer-events: none;
  }

  .vjs-has-started.vjs-user-inactive.vjs-playing .vjs-play-control,
  .vjs-has-started.vjs-user-inactive.vjs-playing .vjs-menu-button {
    opacity: 0;
    pointer-events: none;
    transition: visibility 1s,opacity 1s;
    visibility: visible;
  }

  .video-js:not(.vjs-fullscreen) {
    svg.fa-expand-wide{
      transition: all .1s;
      display: flex;
    }
    svg.fa-down-left-and-up-right-to-center{
      display: none;
    }
  }
  .video-js.vjs-fullscreen {
    svg.fa-down-left-and-up-right-to-center{
      transition: all .1s;
      display: flex;
    }
    svg.fa-expand-wide{
      display: none;
    }

    .scaleup-search-button,
    .scaleup-ai {
      opacity: 0.4 !important;
      pointer-events: none !important;
    }
  }

   .video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-vertical, .video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-vertical, .video-js .vjs-volume-panel.vjs-hover .vjs-mute-control~.vjs-volume-control.vjs-volume-vertical, .video-js .vjs-volume-panel.vjs-hover .vjs-volume-control.vjs-volume-vertical, .video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-vertical, .video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-vertical {
     left: -30px;
   }

   .scaleup-summary-button--active .scaleup-search-button,
   .scaleup-summary-button--active .vjs-subs-caps-button {
    opacity: 0.4;
    pointer-events: none;
   }

   .scaleup-summary-button .vjs-menu-button[title]:hover::after,
   .vjs-play-control.vjs-button[title]:hover::after {
     top: -36px;
   }
   .vjs-settings-menu .scaleup-settings-menu[title]:hover::after,
   .scaleup-search-button .vjs-menu-button[title]:hover::after,
   .vjs-picture-in-picture-control.vjs-button[title]:hover::after,
   .vjs-fullscreen-control.vjs-button[title]:hover::after {
    top: -36px;
   }

  .vjs-settings-menu .vjs-subs-caps-button[title]:not([aria-expanded="true"]):hover::after,
  .vjs-settings-menu .scaleup-ai-button[title]:not([aria-expanded="true"]):hover::after,
  .vjs-settings-menu .scaleup-settings-menu[title]:not([aria-expanded="true"]):hover::after,
  .scaleup-search-button .vjs-menu-button[title]:not([aria-expanded="true"]):hover::after,
  .scaleup-summary-button[title]:hover::after,
  .vjs-play-control.vjs-button[title]:hover::after,
  .vjs-picture-in-picture-control.vjs-button[title]:hover::after,
  .vjs-fullscreen-control.vjs-button[title]:hover::after {
    white-space: nowrap;
    height: 32px;
    padding: 8px;
    display: inline-flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    content: attr(title);
    left: 50%;
    top: -36px;
    transform: translate(-50%);
    position: absolute;
    color: rgb(255, 255, 255);
    text-align: center;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 130%;
    letter-spacing: -0.24px;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.9);
    transition: ease-in-out .5s;
    pointer-events: none;
    z-index: 9999;
  }

  .vjs-menu-button.vjs-toogle-btn button[title]:hover::after {
    display: none !important;
  }

  .vjs-picture-in-picture-control.vjs-button[title]:hover::after {
    left: -2px;
  }
  .vjs-fullscreen-control.vjs-button[title]:hover::after {
    min-width: 80px;
    left: -50%;
  }

  .scaleup-custom-bar.scaleup-custom-bar--wrapper {
    display: flex;
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    height: 40px;
    padding: 0px 8px 8px 8px;
    background: transparent;
    gap: 4px;
    align-items: center;

    &>.vjs-play-control {
      padding: 4px 16px;
      width: 56px;
      height: 100%;
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.90);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background-color .3s ease-in-out, color .15s ease-in-out;

      svg {
        text-rendering: optimizelegibility;
        -webkit-font-smoothing: antialiased;
        pointer-events: none;
      }

      &:hover {
        background: var(--primary-color);
        color: #000000;
      }
      &>.vjs-icon-placeholder:before {
        content: none;
      }
    }

    &>.vjs-play-control.vjs-playing:not(.vjs-ended) {
      svg.fa-pause{
        transition: all .1s;
        display: flex;
      }
      svg.fa-arrow-rotate-left,
      svg.fa-play{
        display: none;
      }
    }
    &>.vjs-play-control.vjs-paused:not(.vjs-ended) {
      svg.fa-play{
        transition: all .1s;
        display: flex;
      }
      svg.fa-arrow-rotate-left,
      svg.fa-pause{
        display: none;
      }
    }
    &>.vjs-play-control.vjs-ended {
      svg.fa-arrow-rotate-left{
        transition: all .1s;
        display: flex;
      }
      svg.fa-play,
      svg.fa-pause{
        display: none;
      }
    }

    &>.scaleup-summary {
      width: 48px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px 12px;
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.90);
      color: #8C8C8C;
      transition: background-color .3s ease-in-out, color .15s ease-in-out;
      .scaleup-summary-button {
        position: absolute;
        width: 100%;
        height: 100%;
        padding: 0;
        &>.vjs-icon-placeholder:before {
          content: none;
        }
      }
      .scaleup-switch-wrapper{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        padding: 8px 0px;
        pointer-events: none;
        .scaleup-switch-background{
          width: 100%;
          height: 100%;
          background: #8C8C8C;
          border-radius: 32px;
          transition: background-color .3s ease-in-out;

          svg.fa-bolt{
            position: absolute;
            left: 3px;
            top: 9px;
            width: 6px;
            height: 6px;
            transition: all 0.3s ease-in-out 0s;
          }
          ::before {
            position: absolute;
            content: "";
            left: 0px;
            top: 6px;
            display: block;
            height: 12px;
            width: 12px;
            border-radius: 9999px;
            background-color: rgb(255, 255, 255);
            box-shadow: rgba(100, 116, 139, 0.325) 0px 3px 10px;
            transition: all 0.3s ease-in-out 0s;
          }
        }
      }
      &:hover {
        background: var(--primary-color);
      }
    }
    &>.scaleup-summary.vjs-toogle-btn {
      color: var(--primary-color);

      .scaleup-switch-background {
        background: var(--primary-color);

        ::before {
          transform: translateX(100%);
        }
        svg.fa-bolt {
          transform: translateX(200%);
        }
      }

      &::before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.9);
        border-radius: 4px;
        z-index: 0;
      }

      &:hover {
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          top: 0;
          background-color: #fff;
          border-radius: 4px;
          z-index: 0;
        }

        &::after {
          content: '';
          position: absolute;
          left: -2px;
          right: -2px;
          bottom: -2px;
          top: -2px;
          background-color: var(--primary-color);
          border-radius: 4px;
          opacity: 0.8;
          z-index: 1;
        }

        .scaleup-summary,
        button {
          z-index: 2;
        }
      }
    }

    &>.vjs-control-bar {
      display: flex;
      height: 32px;
      width: 100%;
      right: 8px;
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.90);
      position: relative;
      padding: 4px 4px 4px 12px;
      gap: 4px;

      &>.vjs-volume-panel.vjs-volume-panel-vertical {
        &>.vjs-volume-control.vjs-volume-vertical{
          height: 88px;
          width: 32px;
          border-radius: 4px;
          background-color: rgba(0,0,0,0.9);
          padding: 8px 10px;
          height: 88px;
          display: flex;
          align-items: center;
          justify-content: center;
          bottom: 96px;
          margin: 0px;

          &>.vjs-volume-bar{
            display: flex;
            height: 100%;
            width: 4px;
            border-radius: 2px;
            margin: 0px;
            position: relative;
            &>.vjs-volume-level{
              border-radius: 2px;
              background-color: var(--primary-color);
              width: 100%;
              &:before {
                position: relative;
                left: -2px;
                top: -12px;
                z-index: 1;
                font-size: 8px;
              }
            }
          }
          &:hover {
            transition: all .5s;
            &>.vjs-volume-bar{
              width: 6px;
              flex-shrink: 0;
              border-radius: 4px;
              &>.vjs-mouse-display .vjs-volume-tooltip{
                left: 16px;
                top: -10px;
                background: rgba(255, 255, 255, 1);
                background-color: rgba(255, 255, 255, 1);
                color: rgba(0, 0, 0, 1);
                box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
                z-index: 1 !important;
                transition: all .2s !important;
                border-radius: 4px !important;
                font-family: Inter;
                font-size: 10px;
                font-style: normal;
                font-weight: 600;
                line-height: 130%; /* 13px */
                letter-spacing: -0.2px;
                padding: 4px;
                min-width: 32px;

                &:after{
                  content: " ";
                  position: absolute;
                  top: 50%;
                  left: -3px;
                  margin-top: -4px;
                  border-width: 4px;
                  border-style: solid;
                  border-color: transparent transparent rgba(255, 255, 255, 1) rgba(255, 255, 255, 1) ;
                  border-radius: 0px 0px 0px 2px;
                  transform: rotate(45deg);
                }
              }
              &>.vjs-volume-level:before{
                font-size: 12px;
                left: -3px;
                top: -10px;
              }
            }
          }
        }

        &>.vjs-mute-control{
          display: flex;
          justify-content: flex-start;
          align-items: center;

          &>.vjs-icon-placeholder:before {
            content: none;
          }
        }

        svg.fa-volume {
          margin-left: -1px;
        }

        &>.vjs-vol-0 {
          svg.fa-volume-xmark {
            transition: all .2s;
            display: flex;
          }
          svg.fa-volume-low,
          svg.fa-volume,
          svg.fa-volume-high {
            display: none;
          }
        }
        &>.vjs-vol-1 {
          svg.fa-volume-low {
            transition: all .2s;
            display: flex;
          }
          svg.fa-volume-xmark,
          svg.fa-volume,
          svg.fa-volume-high {
            display: none;
          }
        }
        &>.vjs-vol-2 {
          svg.fa-volume {
            transition: all .2s;
            display: flex;
          }
          svg.fa-volume-xmark,
          svg.fa-volume-low,
          svg.fa-volume-high {
            display: none;
          }
        }
        &>.vjs-vol-3 {
          svg.fa-volume-high {
            transition: all .2s;
            display: flex;
          }
          svg.fa-volume-xmark,
          svg.fa-volume,
          svg.fa-volume-low {
            display: none;
          }
        }
      }

      &>.vjs-fullscreen-control {
        display: flex;
        align-items: center;
        justify-content: center;

        &>.vjs-icon-placeholder:before {
          content: none;
        }
      }

      &>.vjs-menu-button.vjs-hover,
      &>.vjs-picture-in-picture-control:hover,
      &>.vjs-fullscreen-control:hover,
      &>.vjs-subs-cap-button:hover,
      &>.vjs-subs-cap-button.vjs-hover {
        color: var(--primary-color);
        transition: all .2s;
      }
      &>.vjs-menu-button,
      &>.vjs-picture-in-picture-control,
      &>.vjs-fullscreen-control,
      &>.vjs-subs-cap-button {
        transition: all .2s;
      }
  }
}

  .video-js .vjs-volume-panel {
    width: 24px;
  }

  .vjs-lock-showing {
    display: block !important;
    opacity: 1;
    visibility: visible;
  }

  .video-js .vjs-play-progress {
    background-color: var(--primary-color);
  }

  .video-js .vjs-time-control {
    color: ${theme.color.grey[12]};
    font-size: 12px;
    font-family: Inter;
    align-items: center;
  }

  .video-js .vjs-current-time,
  .video-js .vjs-duration,
  .video-js .vjs-time-divider,
  .video-js .vjs-remaining-time
  {
    display: none !important;
  }

  .video-js .vjs-picture-in-picture-control {
    width: 24px;
    cursor: pointer;
  }

  .vjs-control .vjs-button {
    width: 24px;
    height: 100%;
  }

  .video-js .vjs-quality-selector,
  .video-js.vjs-volume-panel,
  .video-js .vjs-subtitles-button,
  .video-js .vjs-captions-button,
  .video-js .vjs-playback-rate,
  .video-js .vjs-fullscreen-control,
  .video-js .vjs-menu-button,
  .video-js .vjs-subs-caps-button {
    width: 24px;
  }

  .video-js .vjs-subs-caps-button {
    display: flex;
    justify-content: center;
    align-items: center;
    &>i{
      position: absolute;
      margin: auto;
      pointer-events: none;
      user-select: none;
    }
    &>.vjs-icon-placeholder:before {
      content: none;
    }

    &>.vjs-menu:not(.vjs-lock-showing),
    &>.vjs-lock-showing .vjs-texttrack-settings {
      display: none;
    }

    &>.vjs-menu .vjs-menu-content {
      right: -88px;
    }
  }

  .video-js .vjs-time-control {
    padding: 0px;
    width: auto;
    text-align: center;
    display: flex;
    justify-content: center;
    font-size: 12px;
    font-family: Inter;
    color: ${theme.color.grey[12]};
    min-width: 11px;
  }

  .video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-hover {
    width: 144px;
  }

  .vjs-playback-rate .vjs-playback-rate-value,
  .vjs-button > .vjs-icon-placeholder {
    font-size: 13px;
    line-height: 48px;
    font-weight: 600;
  }

  .vjs-button.scaleup-ai-button,
  .vjs-button.scaleup-settings-menu,
  .vjs-button.scaleup-search-button
   {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .video-js:not(.vjs-has-started) .vjs-watermark-content {
    display: none !important;
  }

  .vjs-watermark-content {
    position: absolute;
    user-select: none;
  }

  .vjs-menu li.vjs-selected:focus,
  .vjs-menu li.vjs-selected:hover,
  .rjs-focus-visible .vjs-menu li.vjs-selected:hover,
  .vjs-menu li.vjs-selected,
  .vjs-menu li.vjs-selected::before{
    background: transparent;
    color: ${theme.color.grey[12]};
  }

  .vjs-menu-item,
  .vjs-menu-item::before{
    display: flex;
    align-items: center;
    background: transparent;
    color: transparent;
  }

  .scaleup-list-icon__left-wrapper,
  .scaleup-item__icon-wrapper,
  .scaleup-setting-menu-header__icon,
  .vjs-menu li.vjs-selected::before,
  .vjs-menu-item::before{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    font-size: 12px;
  }

  .vjs-menu li{
    list-style: none;
    margin: 0;
    padding: 0;
    text-align: center;
    line-height: 0;
    width: 100% !important;
  }

  .video-js .vjs-settings-menu .vjs-menu .vjs-zmenu-content {
    border: none !important;
    border-radius: 3px !important;
    padding: 0 !important;
    margin: 0 !important;
    max-height: 25em !important;
  }

  .vjs-workinghover .scaleup-ai:hover .vjs-menu,
  .vjs-workinghover .vjs-settings-menu:hover .vjs-menu {
    display: none;
  }

  .video-js.scaleup-ai-button .vjs-lock-open,
  .video-js.scaleup-search-button .vjs-lock-open,
  .video-js .vjs-settings-menu .vjs-lock-open {
    display: block !important;
  }

  .video-js
    .vjs-settings-menu
    button.vjs-button
    span.vjs-icon-placeholder:before {
    -moz-transition: transform 0.3s ease;
    -webkit-transition: transform 0.3s ease;
    transition: transform 0.3s ease;
  }

  .video-js
    .vjs-settings-menu.vjs-toogle-btn
    button.vjs-button
    span.vjs-icon-placeholder:before {
    -ms-transform: rotate(60deg);
    -moz-transform: rotate(60deg);
    -webkit-transform: rotate(60deg);
    transform: rotate(60deg);
  }

  .video-js .vjs-button .vjs-menu:before,
  .video-js .vjs-button .vjs-menu:after {
    display: none !important;
  }

  .video-js
    .vjs-menu-button-popup
    .vjs-menu
    .vjs-menu-content
    .vjs-menu-item-text {
      color: rgba(255, 255, 255, 1);
      text-align: center;
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 100%; /* 14px */
      letter-spacing: -0.28px;
  }

  .video-js .scaleup-sm-top-level-header {
    text-transform: capitalize !important;
    text-align: left !important;
    pointer-events: none;
    border-bottom: 1px solid ${theme.color.grey[6]};
  }

  .video-js .vjs-hide-settings-menu-item {
    display: none !important;
  }

  .vjs-settings-menu-is-loaded button.vjs-button[title]:before,
  .vjs-settings-menu-is-loaded button.vjs-button[title]:after {
    display: none !important;
  }

  .video-js .vjs-settings-menu .vjs-captions-menu-item .vjs-icon-placeholder {
    position: relative;
  }

  .video-js
    .vjs-settings-menu
    .vjs-captions-menu-item
    .vjs-icon-placeholder:before {
    content: "\f10d" !important;
    font-size: 16px !important;
    vertical-align: bottom !important;
  }

  .video-js .vjs-text-track-settings select {
    color: #000 !important;
    border: none !important;
    padding: 3px 8px !important;
    margin-right: 1em !important;
    margin-bottom: 0.5em !important;
    border-radius: 4px !important;
    font-size: 13px !important;
  }

  .vjs-settings-menu-mobile .vjs-control-text {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  .vjs-settings-menu-mobile .vjs-menu-content li.vjs-selected,
  .vjs-settings-menu-mobile .vjs-settings-menu-mobile-list li.vjs-selected {
    border-radius: 3px;
  }

  //Reseting videojs configs
  .vjs-menu-button-popup .vjs-menu {
    position: unset;
    bottom: auto;
    width: auto;
    left: auto;
    height: auto;
    margin-bottom: 0;
    border-top-color: transparent;
}

  .scaleup-list-item{
    display: flex;
    padding: 8px 20px !important;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    height: 40px;
    transition: .3s background-color ease-in-out;
  }

  .video-js .scaleup-sm-list-item {
    text-transform: capitalize !important;
    text-align: left !important;
    color: ${theme.color.grey[12]};
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
  }

  .video-js .scaleup-sm-list-item span {
    float: right !important;
    width: 50% !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    text-align: right !important;
  }

  .scaleup-list-item__right-wrapper__icon,
  .scaleup-setting-menu-header__left-wrapper{
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
  }

  .scaleup-setting-menu-header__span {
    position: absolute;
    top: auto;
    right: 86px;
    text-align: center;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%; /* 14px */
    letter-spacing: -0.28px;
    text-transform: initial !important;
    color: rgba(255, 255, 255, 1);
  }

  .video-js:has(.vjs-picture-in-picture-control) .vjs-menu .vjs-menu-content{
    right: -60px;
  }

  .vjs-menu{
    z-index: 999 !important;
    position: absolute !important;

    &>.vjs-menu-content{
      flex-grow: 1;
      overflow: auto;
      display: flex;
      min-width: 240px;
      width: 240;
      height: auto;
      min-height: 0;
      padding: 0;
      flex-direction: column;
      align-items: flex-start;
      position: absolute;
      right: -32px;
      bottom: 32px;
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.90);
      transition: .3s background-color ease-in-out;
      &>.scaleup-list-item{
        text-transform: capitalize !important;

        &>.scaleup-list-item__left-wrapper {
          display: flex;
          align-items: center;
          &>.scaleup-list-item__left-wrapper__span {
            color: rgba(255, 255, 255, 1);
            font-family: Inter;
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 100%; /* 14px */
            letter-spacing: -0.28px;
          }
        }
        &>.scaleup-list-item__right-wrapper {
          display: flex;
          align-items: center;
          gap: 8px;
          &>.scaleup-list-item__right-wrapper__span {
            color: rgba(255, 255, 255, 1);
            font-family: Inter;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 100%; /* 12px */
            letter-spacing: -0.24px;
          }
          &>.scaleup-list-item__right-wrapper__icon {
            height: 24px;
            width: 24px;
            text-align: center;
            color: rgba(255, 255, 255, 1) !important;
            &>.fa-chevron-right {
              height: 12px !important;
            }
          }
        }
        &:hover{
          transition: .3s background-color ease-in-out;
          background-color: #262626;
        }
      }

      &>.scaleup-setting-menu-header,
      &>.vjs-menu-item {
        padding: 8px 20px !important;
        height: 40px;
        gap: 4px;
        text-transform: initial;
      }

      &>.scaleup-setting-menu-header{
        display: flex;
        width: 100%;
        align-items: center;
        border-bottom: 1px solid #262626;

        &>.scaleup-setting-menu-header__left-wrapper .scaleup-setting-menu-header__icon{
          color: rgba(255, 255, 255, 1) !important;
          &>.fa-chevron-left {
            height: 12px !important;
          }
        }
      }

      &>.vjs-menu-item {
        transition: .3s background-color ease-in-out;
        &>.scaleup-item__icon-wrapper .fa-check {
          width: 12px !important;
        }
        &:hover {
          transition: .3s background-color ease-in-out;
          background-color: #262626 !important;
        }
      }
    }
  }

    .video-js
    .vjs-settings-menu
    svg.fa-gear{
      -moz-transition: transform 0.3s ease;
      -webkit-transition: transform 0.3s ease;
      transition: transform 0.3s ease;
      position: absolute;
      inset: 0;
      margin: auto;
      pointer-events: none;
  }

  .video-js
    .vjs-settings-menu.vjs-toogle-btn
    svg.fa-gear{
      -ms-transform: rotate(60deg);
      -moz-transform: rotate(60deg);
      -webkit-transform: rotate(60deg);
      transform: rotate(60deg);
  }

  .fa-gear,
  svg.fa-magnifying-glass{
    position: absolute;
    inset: 0;
    margin: auto;
    pointer-events: none;
    user-select: none;
  }

  .video-js.scaleup-search-button .scaleup-search-display {
    position: absolute;
    display: flex;
    justify-content: flex-end;
    bottom: 8px;
    top: 8px;
    right: 8px;
    width: 100%;
    pointer-events: none;

    will-change: transform;
    transition: transform .5s ease-in-out !important;
    transform: translateX(100%) !important;
    z-index: 1;

    &.toggle-search {
      transform: translateX(0) !important;
    }

    &>.scaleup-search-panel {
      margin: 0;
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.90);
      pointer-events: auto;
      width: 100%;
      max-width: 455px;
      visibility: visible;
      opacity: 1;
      box-sizing: border-box;

      @media (max-width: 768px) {
        max-width: calc(100% - 16px);
      }

      &>div.scaleup-search__panel-wrapper{
        display: flex;
        padding: 8px;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
        gap: 8px;
        align-self: stretch;
        height: 100%;

        &>div.scaleup-search__input-wrapper{
          display: flex;
          align-items: center;
          width: 100%;
          gap: 8px;
          height: 40px;
          background: transparent;
          pointer-events: auto;
          position: sticky;

          &>input.scaleup-search__input{
            display: flex;
            height: 100%;
            width: 100%;
            border: 1px solid rgba(64, 64, 64, 1);
            border-radius: 4px;
            background: rgba(31, 31, 31, 1);
            padding: 8px 12px;

            color: rgba(245, 245, 245, 1);
            font-family: Inter;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 100%; /* 14px */
            letter-spacing: -0.28px;
            &:focus {
              box-shadow: 0px 0px 0px 2px var(--primary-color);
              outline: transparent;
            }
          }
          &>.scaleup-search__input--close__button{
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 auto;
            width: 40px;
            height: 100%;
            padding: 8px;
            background: rgba(31, 31, 31, 1);
            border-radius: 4px;
            cursor: pointer;
            transition: .3s ease-in-out background-color;

            &:hover {
              background: #404040;
            }

            &>.fa-xmark{
              height: 12px;
              width: 12px;
            }
          }
        }

        &>.scaleup-search__results-wrapper {
          display: flex;
          width: 100%;
          height: 100%;
          flex-direction: column;
          pointer-events: auto;
          gap: 8px;
          overflow-y: scroll;
          &>.scaleup-search__results--list {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            color: rgba(89, 89, 89, 1);
            font-family: Inter;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 140%;
            letter-spacing: -0.28px;

            width: 100%;
            padding: 8px 8px 8px 12px;
            cursor: pointer;
            gap: 8px;
            border-radius: 4px;
            overflow-x: clip;

            transition: .3s color ease-in-out;

            &>span{
              display: flex;
              white-space: nowrap;
              height: 24px;
              padding: 4px 8px;
              align-items: center;
              border-radius: 4px;
              border: 1px solid rgba(31, 31, 31, 1);;
              background: rgba(31, 31, 31, 1);
              right: 0px;
              top: 0px;

              font-family: Inter;
              font-size: 12px;
              font-style: normal;
              font-weight: 500;
              line-height: 14px; /* 116.667% */
              letter-spacing: -0.24px;
              color: rgba(89, 89, 89, 1);
              transition: .3s color ease-in-out, .3s background-color ease-in-out;
            }

            &>p{
              text-align: left;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              color: var(--gray-dark-11, #A0A0A0);

              font-family: Inter;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: 140%;
              margin: 0px;
              padding-left: 5px;
              transition: .3s color ease-in-out;
            }
            &:hover {
              background: rgba(38, 38, 38, 1);

              &>p {
                color: rgba(255, 255, 255, 1);
              }

              &>span {
                color: rgba(255, 255, 255, 1);
                border: 1px solid rgba(64, 64, 64, 1);
                background: rgba(64, 64, 64, 1);
              }
            }
          }
        }
      }
    }
    &:not(.toggle-search) .scaleup-search-panel .scaleup-search__panel-wrapper{
      transition visibility 0.5s ease-in-out, opacity 0.5s ease-in-out;
      opacity: 0;
      visibility: hidden;
    }
  }

  .scaleup-search.scaleup-search__results-wrapper.scaleup-search__results--empty__wrapper{
    display: flex;
    justify-content: center;
    align-items:center;
    flex-flow: column nowrap;
    gap: calc(100vh / 24);
    opacity: 1 !important;
  }

  .scaleup-search__results--highlight{
    color: var(--primary-color);
  }

  svg.scaleup-search__results--empty{
    font-size: 80px;
  }

  span.scaleup-search__results--empty{
    color: ${theme.color.grey[11]};
    text-align: center;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.5px;
    pointer-events: none;
    user-select: none;
  }

  .vjs-error .vjs-error-display{
    background: #1F1F1F;

    &:before,
    &>.vjs-modal-dialog-description,
    &>.vjs-modal-dialog-content {
      display: none;
    }
    &>.scaleup-error-wrapper p.scaleup-error-code{
      color: #595959;
      font-family: Inter;
      font-size: 32px;
      font-style: normal;
      font-weight: 500;
      line-height: 140%;
      letter-spacing: -0.64px;
    }

    &>.scaleup-error-wrapper span.scaleup-error-message{
      color: #FFFFFF;
      font-family: Inter;
      font-size: 32px;
      font-style: normal;
      font-weight: 500;
      line-height: 140%;
      letter-spacing: -0.64px;
    }
  }

  .vjs-error .vjs-error-display {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items:center;
    flex-flow: column nowrap;
    gap: 24px;
    opacity: 1 !important;
    padding: 8px;
    &>.scaleup-error-wrapper {
      padding: 24px;
      display: flex;
      align-content: center;
      align-items: center;
      flex-direction: column;
    }
  }

  //MEDIA QUERIES
   @media (max-width: 767px) {
     span.scaleup-error-message,
     p.scaleup-error-code{
       font-size: 14px !important;
       letter-spacing: -0.28px !important;
     }
     svg.fa-rotate-right{
       height: 10px;
       margin-left: 8px;
     }
   }
   @media (min-width: 768px) {
     span.scaleup-error-message,
     p.scaleup-error-code{
       font-size: 20px !important;
       letter-spacing: -0.38px !important;
     }
     svg.fa-rotate-right{
       height: 16px;
       margin-left: 8px;
     }
   }
   @media (min-width: 1024px) {
     span.scaleup-error-message,
     p.scaleup-error-code{
       font-size: 24px !important;
       letter-spacing: -0.48px !important;
     }
     svg.fa-rotate-right{
       height: 20px;
       margin-left: 8px;
     }
   }
   @media (min-width: 1280px){
     span.scaleup-error-message,
     p.scaleup-error-code{
       font-size: 28px !important;
       letter-spacing: -0.56px !important;
     }
     svg.fa-rotate-right{
       height: 24px;
       margin-left: 8px;
     }
   }
   @media (min-width: 1536px) {
     span.scaleup-error-message,
     p.scaleup-error-code{
       font-size: 32px !important;
       letter-spacing: -0.64px !important;
     }
     svg.fa-rotate-right{
       height: 28px;
       margin-left: 8px;
     }
   }
`,
);
